import React from "react";

export function OutlineText(props) {
    return (
        <div className={props.className}>
            <div style={{
                width: 'max-content',
                height: 'max-content',
                '-webkit-text-stroke': props.webkitTextStroke
            }}>{props.text}</div>
            <div style={{
                position: 'absolute',
                width: 'max-content',
                height: 'max-content',
            }}>{props.text}</div>
        </div>
    );
}
